import React, { Component, PropTypes } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import _pickBy from 'lodash/pickBy';

import SelectList from '../components/Common/SelectList/SelectList';

import {
    setNewBookingJourneyToLocation,
    setNewBookingCustomJourneyToLocation,
} from '../actions/newBooking';

class DestinationLocationSelectorContainer extends Component {
    render() {
        const {
            person,
            journeyToLocationId,
            setNewBookingJourneyToLocation,
            otherJourneyToLocation,
            setNewBookingCustomJourneyToLocation,
        } = this.props;

        let freeTextProps = {
            freeTextValue: otherJourneyToLocation,
            setFreeTextItem: (value) => {

                // the CustomJourneyToLocation max char length is set at 50 in db. It can pass as null so it registers as not being used
                if (!value || value.length <= 50) {
                    setNewBookingCustomJourneyToLocation(value);
                }
            },
        };
        
        return (
            <SelectList
                title="Journey To"
                items={this.props.locations}
                selectedItemId={this.props.journeyToLocationId}
                setSelectedItem={this.props.setNewBookingJourneyToLocation}
                {...freeTextProps}
            />
        );
    }
}

function mapStateToProps(state) {
    const locations = _pickBy(
        state.entities.locations,
        location => location.id !== state.newBooking.pickupLocationId
    );
    
    const { journeyToLocationId, otherJourneyToLocation } = state.newBooking;


    return {
        locations,
        journeyToLocationId,
        otherJourneyToLocation,
    };
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        setNewBookingJourneyToLocation,
        setNewBookingCustomJourneyToLocation,
    }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(DestinationLocationSelectorContainer);



// WEBPACK FOOTER //
// ./scripts/containers/JourneyToLocationSelectorContainer.jsx